import { motion } from "framer-motion";
import { Monitor, Rocket, CurrencyGbp } from "@phosphor-icons/react";

const steps = [
  {
    num: "01",
    icon: Monitor,
    title: "Preview Your Club's Site",
    description:
      "Enter your club name and colours into our free demo. See exactly what your members will see — takes 30 seconds, no sign up needed.",
  },
  {
    num: "02",
    icon: Rocket,
    title: "Activate & Go Live",
    description:
      "Love it? Hit activate and start fundraising. After payment, your club admin dashboard is live immediately. Set up Stripe Connect, customise your prizes, and your public predictor page goes live once we've verified your payment details.",
  },
  {
    num: "03",
    icon: CurrencyGbp,
    title: "Watch The Funds Roll In",
    description:
      "Members pay to enter via Stripe, straight to your club's bank account. You keep 100% of every entry fee — the only deduction is standard Stripe processing.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.4 },
  }),
};

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-10 lg:py-14 px-6 bg-[#F8FAFA] border-t border-[#1D3557]/5"
    >
      <div className="max-w-6xl mx-auto">
        <p className="font-body text-xs font-bold uppercase tracking-[0.2em] text-[#E63946] mb-3">
          How It Works
        </p>
        <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight leading-none text-[#1D3557] mb-6 lg:mb-8">
          Three Simple Steps
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-30px" }}
              variants={fadeUp}
              className="relative bg-white border border-[#1D3557]/5 p-5 lg:p-7 overflow-hidden"
              data-testid={`how-it-works-step-${step.num}`}
            >
              <span className="absolute -bottom-2 -right-1 text-[7rem] font-heading font-black text-[#1D3557]/[0.03] leading-none select-none pointer-events-none">
                {step.num}
              </span>
              <div className="relative z-10">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-heading font-bold text-lg tracking-tight text-[#1D3557]">
                    {step.title}
                  </h3>
                  <step.icon size={22} weight="duotone" className="text-[#E63946] flex-shrink-0 ml-3" />
                </div>
                <p className="font-body text-sm text-[#1D3557]/55 leading-relaxed">
                  {step.description}
                </p>
                {step.num === "01" && (
                  <a
                    href="https://app.targetfunder.com/demo/create"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-body text-sm font-semibold text-[#E63946] hover:text-[#d32f3c] transition-colors mt-2 inline-block"
                    data-testid="how-it-works-try-now"
                  >
                    Try it now &rarr;
                  </a>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
